import { Box, CircularProgress } from "@mui/material";
import React from "react";

const MuPb = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh" // Take up the full viewport height
    >
      <CircularProgress />
    </Box>
  );
};

export default MuPb;
